module.exports = "<div class=\"weui_cells\" :class=\"typeClass\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cells.vue
 ** module id = 61
 ** module chunks = 0
 **/